import Hero from '../components/sections/Hero';
import ServicesPreview from '../components/sections/ServicesPreview';
import ProcessTimeline from '../components/sections/ProcessTimeline';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import TargetClients from '../components/sections/TargetClients';
import CTABanner from '../components/sections/CTABanner';

export default function Home() {
  return (
    <>
      <Hero />
      <ServicesPreview />
      <ProcessTimeline />
      <WhyChooseUs />
      <TargetClients />
      <CTABanner />
    </>
  );
}
